import "./Image.css";

export const Image = () => {
  return (
    <>
      <div className="image__container">
        <img
          src="https://cdn.pixabay.com/photo/2021/11/09/10/36/boy-6781192_1280.jpg"
          alt="image__name"
          className="img__responsive"
        />
      </div>
    </>
  );
};
